import React from 'react'

export const rolloverBodyContent = {
  sectionOne: {
    title: 'Why is data discount better than data rollover?',
    text: (
      <p data-testid="data-discount-offer">
        Unlike other mobile networks, we knock money off your bill for data you
        haven’t used. And unlike data rollover plans, you won’t build up a pool
        of data that you’ll never use. Our data discount plans are perfect for
        people who don’t use all their data and want to save money every month.
      </p>
    ),
  },
  sectionTwo: {
    title: 'How does data discount work?',
    text: (
      <p data-testid="data-discount-work">
        The way it works is simple. The base cost of our data discount plans is
        £5, which covers unlimited standard calls, texts and running the
        network. The rest is simply for data. So we think it’s only fair to take
        the data you haven’t used and give you money back for it - at the same
        rate you bought it, £1 per GB.
        <br />
        We even calculate using remaining MBs, not GBs.
      </p>
    ),
  },
  cta: 'View our data discount plans',
}
